import { createContext } from "react";

const TrainerContext = createContext<{
  setTrainerState: (data: any) => void;
  getTrainerState: () => { [key: string]: any };
} | null>(null) as React.Context<{
  setTrainerState: (data: any) => void;
  getTrainerState: () => { [key: string]: any };
}>;

export default TrainerContext;
